// src/components/PaymentModal.tsx
import React from 'react';
import { CreditCard, X, CheckCircle2, ClipboardCopy } from 'lucide-react';

interface PaymentModalProps {
    paymentModalJob: any;
    setPaymentModalJob: (val: any | null) => void;
    paymentMessage: string;
    setPaymentMessage: (val: string) => void;
    handleCopyPaymentMessage: () => void;
    isCopied: boolean;
}

export default function PaymentModal({
    paymentModalJob, setPaymentModalJob, paymentMessage, 
    setPaymentMessage, handleCopyPaymentMessage, isCopied
}: PaymentModalProps) {
    
    if (!paymentModalJob) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100] backdrop-blur-sm p-4 no-print">
            <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in-95 duration-200">
                <div className="px-6 py-4 border-b border-slate-100 dark:border-slate-700 flex justify-between items-center bg-slate-50 dark:bg-slate-900/50">
                    <h3 className="font-bold text-lg text-slate-800 dark:text-white flex items-center">
                        <CreditCard className="w-5 h-5 mr-2 text-indigo-600 dark:text-indigo-400" /> Betaalverzoek
                    </h3>
                    <button onClick={() => setPaymentModalJob(null)}><X className="w-5 h-5 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200" /></button>
                </div>
                <div className="p-6">
                    <p className="text-sm text-slate-600 dark:text-slate-300 mb-4">
                        De betaallink is klaar! Kopieer het onderstaande bericht om naar de klant te sturen (bijv. via WhatsApp).
                    </p>
                    
                    <div className="relative mb-4">
                        <textarea 
                            className="w-full h-56 p-3 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 text-sm text-slate-900 dark:text-white resize-none focus:ring-2 focus:ring-indigo-500 outline-none"
                            value={paymentMessage}
                            onChange={(e) => setPaymentMessage(e.target.value)}
                        />
                    </div>

                    <div className="flex gap-3">
                        <button 
                            onClick={handleCopyPaymentMessage}
                            className={`flex-1 py-3 text-white rounded-xl transition font-bold flex justify-center items-center ${isCopied ? 'bg-green-500 hover:bg-green-600' : 'bg-indigo-600 hover:bg-indigo-700 shadow-lg shadow-indigo-200 dark:shadow-none'}`}
                        >
                            {isCopied ? <CheckCircle2 className="w-5 h-5 mr-2" /> : <ClipboardCopy className="w-5 h-5 mr-2" />}
                            {isCopied ? "Gekopieerd!" : "Kopieer Bericht"}
                        </button>
                    </div>
                    <div className="mt-4 text-center">
                        <a href={paymentModalJob.paymentLink} target="_blank" rel="noreferrer" className="text-sm text-indigo-600 dark:text-indigo-400 hover:underline font-medium">
                            Link zelf openen in browser
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}